import { ConfigEntry } from '../services/config.service';

/**
 * School year configuration entries
 * All configurations related to school year calculations and display
 *
 * ⚠️ When changing default values, update the following docs:
 *   - docs/employee/admin-aktionen.md
 */
export const SCHOOLYEAR_CONFIG: ConfigEntry[] = [
  {
    key: 'CURRENT_SCHOOL_YEAR_OVERRIDE',
    value: null,
    description:
      'Überschreibt das aktuelle Schuljahr (leer = automatisch berechnet basierend auf aktuellem Datum)',
    searchTags: [
      'schuljahr',
      'jahr',
      'testing',
      'override',
      'überschreiben',
      'aktuell',
    ],
    group: 'schoolyear',
    type: 'number',
    defaultValue: null,
  },
  {
    key: 'MIN_SCHOOL_YEAR',
    value: 2026,
    description:
      'Frühestes verfügbares Schuljahr (für Mitarbeiter-Ansicht und historische Daten)',
    searchTags: [
      'schuljahr',
      'minimum',
      'employee',
      'mitarbeiter',
      'frühestes',
      'historisch',
    ],
    group: 'schoolyear',
    type: 'number',
    defaultValue: 2026,
  },
  {
    key: 'UPCOMING_YEARS_COUNT',
    value: 4,
    description:
      'Anzahl zukünftiger Schuljahre in Dropdowns (für Kunden-Ansicht)',
    searchTags: [
      'schuljahr',
      'dropdown',
      'customer',
      'kunde',
      'anzahl',
      'zukunft',
    ],
    group: 'schoolyear',
    type: 'number',
    defaultValue: 4,
  },
];

/**
 * School year group metadata
 */
export const SCHOOLYEAR_GROUP_NAME = 'Schuljahr';
export const SCHOOLYEAR_GROUP_DESCRIPTION =
  'Einstellungen für Schuljahr-Berechnungen und Anzeige in beiden Apps';
